import React, { useRef, useState } from 'react';
import ExpCard from "./expCard"
import Tag from "../components/Tag"
import { Checkbox, Icon } from '@kdcloudjs/kdesign'

import "./app.less"

function ExpCompany(props) {
    const { I18N, data } = props

    const {
        label = [],
        year = null,
        month = null,
        day = null,
        change = null,
        promote = null,
        record = null,
        startDate = "",
        orbit = []
    } = data

    const [isMoving, setIsMoving] = useState(false)

    const type2colorMap = {
        "primary": "1",
        "part-time": "2",
        "be-on-loan": "3",
        "assignment": "4",
        "rank-promotion": "5",
        "special-org": "6"
    }

    const [typeCheckedVal, setTypeCheckedVal] = useState(["primary", "part-time", "be-on-loan", "assignment", "rank-promotion", "special-org"])

    const listBoxRef = useRef(null)

    const checkboxList = [
        { name: I18N("check.main"), val: "primary" },
        { name: I18N("check.part"), val: "part-time" },
        { name: I18N("check.loan"), val: "be-on-loan" },
        { name: I18N("check.od"), val: "assignment" },
        { name: I18N("check.promotion"), val: "rank-promotion" },
        { name: I18N("check.expert"), val: "special-org" },
    ]

    return (
        <div className="exp-company-containt">
            <div className="head">
                <div className="title">{I18N("main.title")}</div>
                <div className="tags-box">
                    {
                        [...label].splice(0, 2).map((txt, i) => {
                            return (
                                <Tag key={`tag${i}`} color="end">{txt}</Tag>
                            )
                        })
                    }
                    {
                        label.length > 2 && (
                            <>
                                <span className="ikd-tag status end ikd-tag-hover">
                                    {`+${label.length - 2}`}
                                    <div className="hover-list">
                                        {
                                            label.map((txt, i) => {
                                                if (i > 1) {
                                                    return (
                                                        <div key={`titem${i}`} className="hover-item">{txt}</div>
                                                    )
                                                }
                                            })
                                        }

                                    </div>
                                </span>
                            </>
                        )
                    }
                </div>
                <div className="checkbox-box">
                    <Checkbox.Group checkboxType={'default'}
                        onChange={(e, value) => {
                            setTypeCheckedVal(value)
                        }} value={typeCheckedVal}
                    >
                        {
                            checkboxList.map(({ name, val }, i) => {
                                return (
                                    <Checkbox
                                        value={val}
                                        className={`i-check-${i + 1}`}
                                        key={val}
                                        style={{ marginRight: "17px" }}
                                    >
                                        {name}
                                    </Checkbox>
                                )
                            })
                        }

                    </Checkbox.Group>
                </div>
            </div>
            <div className="desc">
                {I18N("desc.entryed")}
                {
                    year !== null && year !== 0 && (
                        <>
                            <span className="dates">{year}</span>{I18N("desc.year")}
                        </>
                    )
                }
                {
                    month !== null && month !== 0 && (
                        <>
                            <span className="dates">{month}</span>{I18N("desc.moon")}
                        </>
                    )
                }
                {
                    day !== null && day !== 0 && (
                        <>
                            <span className="dates">{day}</span>{I18N("desc.day")}
                        </>
                    )
                }
                ，
                {I18N("desc.head")}
                <span className="times">{change}</span>{I18N("desc.change")}，
                <span className="times">{promote}</span>{I18N("desc.pro")}，
                <span className="times">{record}</span>{I18N("desc.expert")}。
            </div>
            <div className="exp-map">
                <span className="exp-start">{startDate}{I18N("line.entry")}</span>
                <div className="exp-wrapper" ref={listBoxRef}>
                    <div className="exp-list-box"

                        onMouseDown={e => {
                            setIsMoving(true)
                        }}
                        onMouseMove={e => {
                            if (!isMoving) return

                            e.persist()

                            const { movementX } = e

                            listBoxRef.current.scrollLeft -= movementX

                        }}
                        onMouseUp={e => {
                            setIsMoving(false)
                        }}
                    >
                        {
                            orbit.filter(item => typeCheckedVal.indexOf(item.type) > -1)
                                .map((args, i) => {
                                    return (
                                        <div className={`exp-list-item ${i % 2 === 0 ? 'top' : 'bottom'}`} key={i} >
                                            <ExpCard color={"type" + (type2colorMap[args.type])} {...args} />
                                        </div>
                                    )
                                })
                        }
                        <div className="mid-line"></div>
                    </div>
                    <div className="mid-line"></div>
                </div>
                <Icon className="mid-line-arrow" type="arrow-right-solid" />
                <span className="exp-end">
                    {I18N("line.now")}
                </span>
            </div>
        </div>
    );
}

export default ExpCompany;